export enum AutomatedActionRecipientActionType {
    CreateTask = 0,
    SendNotification = 1,
}

// note: currently it is duplicated with FiOnboardingStepNotificationRecipientType
// todo: create general enums that can be used for all recipient selects (onboarding, checklist)
export enum AutomatedActionRecipientType {
    Roles = 0,
    RolesLocal = 1,
    Users = 2,
    EmailAddress = 3,
    SMS = 4,
    Participants = 5,
}

export enum AutomatedActionLocationType {
    OnlyCurrent = 0,
    AnyUserBelongsTo = 1,
}
